
<gw-findings-table [findingsStatus]="'solved'"></gw-findings-table>